export function translateCoercedTime(
  time: Temporal.ZonedDateTime,
  {
    fromTimezoneId,
    toTimezoneId,
  }: { fromTimezoneId: string; toTimezoneId: string },
) {
  const atPlainDateTime = time.toPlainDateTime()
  const offset =
    atPlainDateTime.toZonedDateTime(toTimezoneId).offsetNanoseconds -
    atPlainDateTime.toZonedDateTime(fromTimezoneId).offsetNanoseconds

  return atPlainDateTime.add({ nanoseconds: offset }).toZonedDateTime("UTC")
}

export function getTimezoneAbbreviation(timezone: string) {
  return Intl.DateTimeFormat(undefined, {
    timeZoneName: "short",
    timeZone: timezone,
  })
    .formatToParts()
    .find(({ type }) => type === "timeZoneName")?.value
}

export const displayPlainTime = (plainTime: Temporal.PlainTime) =>
  plainTime.toLocaleString(undefined, { timeStyle: "short" })
export const displayDay = (day: number) => day + 1

export function calculateEventStartCalendarTimezoneCoerced({
  startTime,
  day,
  calendarTimezoneId,
  eventTimezoneId,
  startTemporalZonedDateTime,
}: {
  startTime: string
  day: number
  calendarTimezoneId: string
  eventTimezoneId: string
  startTemporalZonedDateTime: Temporal.ZonedDateTime
}) {
  const eventStartPlainTime = Temporal.PlainTime.from(startTime)
  const eventStartDate = startTemporalZonedDateTime
    .toPlainDate()
    .add({ days: day })

  return translateCoercedTime(
    eventStartDate
      .toPlainDateTime()
      .withPlainTime(eventStartPlainTime)
      .toZonedDateTime("UTC"),
    { fromTimezoneId: eventTimezoneId, toTimezoneId: calendarTimezoneId },
  )
}

export const transitionDays = (
  timezoneId: string,
  calendarStartTemporalInstant: Temporal.Instant,
): Array<Temporal.PlainDate> => {
  const tz = calendarStartTemporalInstant.toZonedDateTimeISO(timezoneId)
  const nextTransition = tz.getTimeZoneTransition("next")
  const previousTransition = tz.getTimeZoneTransition("previous")
  if (nextTransition === null || previousTransition === null) {
    return [tz.toPlainDate()]
  }

  return [
    previousTransition.add({ days: 1 }).startOfDay().toPlainDate(),
    nextTransition.add({ days: 1 }).startOfDay().toPlainDate(),
  ]
}
